import {
  favoriteAddToFolder,
  favoriteCreateFolderAndAdd,
  favoriteCreateFolderAndTransfer,
  favoriteDeferred,
  favoriteDelete,
  favoriteTransferToFolder,
} from '~/utils/toggleFavoriteState';

export function useFavorite() {
  const app = useNuxtApp();

  const onFavoriteDelete = (favorite, article, sendAnalytics = true, cb = () => {}) => {
    favoriteDelete(favorite, article, app, sendAnalytics, cb);
  };

  const onFavoriteCreateFolderAndAdd = (
    nameFolder,
    article,
    sendAnalytics = true,
    cb = () => {},
  ) => {
    favoriteCreateFolderAndAdd(nameFolder, article, app, sendAnalytics, cb);
  };

  const onFavoriteCreateFolderAndTransfer = (
    nameFolder,
    favorite,
    article,
    _sendAnalytics,
    cb = () => {},
  ) => {
    favoriteCreateFolderAndTransfer(nameFolder, favorite, article, undefined, app, cb);
  };

  const onFavoriteTransferToFolder = (favorite, folder, article, _sendAnalytics, cb = () => {}) => {
    favoriteTransferToFolder(favorite, folder, article, undefined, app, cb);
  };

  const onFavoriteAddToFolder = (folder, article, sendAnalytics = true) => {
    favoriteAddToFolder(folder, article, sendAnalytics, app);
  };

  // favoriteDeferred показывает авторизационный пуш, не требует аргументов
  const onFavoriteDeferred = () => {
    favoriteDeferred();
  };

  return {
    onFavoriteDelete,
    onFavoriteCreateFolderAndAdd,
    onFavoriteCreateFolderAndTransfer,
    onFavoriteTransferToFolder,
    onFavoriteAddToFolder,
    onFavoriteDeferred,
  };
}
